import React from 'react';

import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';

let PageNotAvailable = ({ translate }) => {
  return (
    <div >
      <div >
        <h1 className="title">{translate('page-not-available')}</h1>
      </div>
    </div>
  )
}
const viewMapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {

  }
}

PageNotAvailable = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(PageNotAvailable);


export default PageNotAvailable;



// WEBPACK FOOTER //
// ./src/components/PageNotAvailable/PageNotAvailable.js